/*
  Chargeur des correctifs du tunnel de verres, Les Lunettes de Pauline.

  Appele par sections/lens-tunnel.liquid, uniquement sur les fiches ou le tunnel
  s'affiche. Il ne contient rien d'autre que le chargement de ses compagnons,
  afin d'eviter d'avoir a modifier la section :

    lt-correctifs-tunnel.js  correctifs 1 a 5 du tunnel lui-meme
    lt-variante-suivie.js    prix et couleur de la monture reellement choisie
    lt-prix-verres.js        prix d'entree des verres annonce sur la fiche
    lt-garde-fous.js         bornes de saisie et avertissement hors limites
    lt-aide-saisie.js        lecture de l'ordonnance et echelle d'ecart pupillaire
    lt-epaisseur-imposee.js  epaisseur minimale sur les nylor, semi-cerclees et percees
    lt-mutuelle.js           case a cocher sur les conditions de prise en charge
    lt-devis-patient.js      bloc patient : naissance, securite sociale, ordonnance,
                             delivrance, et report de la naissance sur le devis
    lt-devis-lot1.js         mise en forme reglementaire du devis normalise
    lt-devis-appairage.js    prestation d'appairage, rubrique 1.3
    lt-devis-solaire.js      verres teintes : avertissement et remboursement nul

  L'ordre compte pour les deux derniers : ils enveloppent tous deux la fonction
  de composition du devis, et le solaire doit passer en dernier pour ramener a
  zero ce que l'appairage aurait pu ajouter. Attention, cet ordre de liste n'est
  PAS un ordre d'execution garanti : les scripts sont inseres dynamiquement,
  donc asynchrones, et c'est le reseau qui decide qui part le premier. Un
  compagnon qui depend de l'etat pose par un autre, ou du moment ou
  lens-tunnel.js attache ses gestionnaires, doit s'en proteger lui-meme. Deux
  bogues sont venus de la le 13 octobre 2026, tous deux corriges dans
  lt-prix-verres.js : une carte des verres restreinte deux fois, et un lien
  Voir le detail qui ne marchait qu'une fois sur deux.

  POURQUOI L'ORDRE DES BLOCS DE LA FICHE N'EST PAS CORRIGE ICI. La zone d'achat
  etait trop basse : sur la Gigi Studios Lara, ecran de 1440 px, l'encart de
  stock et le calculateur mutuelle s'intercalaient entre le choix de la couleur
  et les boutons, qui tombaient a 719 px. Un compagnon lt-fiche-ordre.js a ete
  ecrit puis retire : il deplacait bien le bloc, mais la mesure prise sur la
  page montrait un deplacement a 2 331 ms pour un premier affichage a 1 388 ms,
  soit un saut visible de la zone d'achat pres d'une seconde apres l'arrivee du
  client. L'ordre des blocs a donc ete corrige dans l'editeur de theme, section
  Informations produit, ou il ne coute rien et ne casse pas la fusion des
  marges verticales dont le theme se sert avec des marges negatives.

  Reglages du devis que l'on peut changer ICI, sans republier les 46 ko de
  lt-devis-lot1.js. Decommenter et modifier, ils sont poses avant le chargement
  des compagnons donc ils prennent le dessus sur les valeurs par defaut :

    window.LT_DEVIS_REGLAGES = { tva: 0.2, livraison: 5.99 };
    window.LT_DEVIS_REFERENCE = { marque: 'Owlet Originals',
                                  matiere: 'Plastique injecte' };

  ATTENTION. Les compagnons sont appeles en reprenant l'adresse de CE fichier,
  donc son jeton de version. Modifier un compagnon sans toucher a lt-correctifs.js
  laisse le CDN servir l'ancienne version du compagnon, sans aucun message
  d'erreur, et ajouter un parametre a l'adresse n'y change rien. Il faut modifier
  une ligne ici, la revision ci-dessous, pour forcer le rafraichissement.

  Revision 26.0, 16 octobre 2026 : la date de naissance devient obligatoire dans
  la fenetre « Vos coordonnees » et figure au bloc patient du devis, a cote du
  nom. Le modele reglementaire identifie le patient par son nom, sa date de
  naissance et son numero de securite sociale. La saisie est verifiee contre le
  numero de securite sociale, qui porte lui-meme l'annee et le mois de
  naissance, et l'accord du participe suit le premier chiffre du numero.
  Correctif 6 dans lt-correctifs-tunnel.js : sous l'encart du devis, une note
  dit que le devis n'a pas a etre envoye a la complementaire et renvoie le
  client a la ligne optique de son tableau de garanties, au panier B.

  Revision 25.2, 13 octobre 2026 : le lien Voir le detail de la ligne de prix
  des verres declenche un clic sur le bouton du theme au lieu de porter
  lui-meme l'attribut data-lens-tunnel-open, auquel le tunnel n'etait pas
  toujours relie.

  Revision 24.2, 13 octobre 2026 : le prix d'entree des verres est annonce sur
  la fiche, juste sous le prix de la monture. Il n'y figurait nulle part : le
  client lisait le prix de la monture, la mention monture seule sans verres, et
  devait ouvrir le tunnel puis saisir ses neuf champs d'ordonnance pour voir le
  premier chiffre. Le montant est calcule sur lens-map.json, la meme source que
  le tunnel, et tient compte de l'epaisseur imposee sur les montures a rainure
  ou percees. Si la carte ne repond pas, rien ne s'affiche.
  La 24.0 avait aussi remplace requestAnimationFrame par setTimeout dans
  lt-variante-suivie.js : dans un onglet d'arriere-plan la page est declaree
  hidden et requestAnimationFrame n'est jamais appele.

  Revision 23.1, 13 octobre 2026 : la monture du tunnel suit la couleur choisie.
  La section publie price: product.price, qui est le prix le plus bas du produit
  et non celui de la couleur affichee, et un variantId fige au rendu de la page.
  Resultat verifie sur Nuxe Iconic01, couleur a 160 euros : en arrivant par
  l'adresse de la couleur, le recapitulatif annoncait 168,99 euros pour un panier
  a 209,00 euros ; en changeant de couleur sur la page, le panier recevait l'autre
  couleur a 119,99 euros. Le compagnon lt-variante-suivie.js corrige l'objet de
  configuration en place, a partir du bloc JSON de variante que le theme tient a
  jour, sans toucher ni a la section ni au fichier minifie. La 23.1 rafraichit en
  plus l'en-tete VOTRE MONTURE du panneau, fabrique une seule fois a l'ouverture
  et donc insensible a la correction de l'objet.

  Revision 22.1, 13 octobre 2026 : epaisseur de verre imposee sur les montures
  dont le verre n'est pas tenu par un cerclage. Sur une semi-cerclee le verre est
  creuse d'une rainure pour le fil nylon, sur une percee il est perce pour des
  vis : on enleve de la matiere la ou le verre est deja le plus fin, et un 1.5
  organique encaisse mal. Le tunnel ne propose donc plus que les epaisseurs
  listees ci-dessous sur les montures qui portent l'etiquette. Les autres
  montures ne sont pas touchees : sans l'etiquette, le compagnon ne fait rien.
  La 22.1 corrige l'affichage des prix : le premier aminci devient le prix
  d'entree de la famille, au lieu d'annoncer celui du 1.5 devenu invendable.

  Reglages de l'epaisseur imposee, modifiables ici :
    etiquette  l'etiquette produit Shopify qui declenche la restriction
    garder     les references de lens-map.json autorisees, dans l'ordre
               d'affichage ; la premiere est celle sur laquelle le client arrive
    note       la phrase affichee au-dessus des cartes d'epaisseur
  Mettre etiquette a '' desactive completement la restriction.
*/
(function () {
  'use strict';

  window.LT_EPAISSEUR_IMPOSEE = window.LT_EPAISSEUR_IMPOSEE || {
    etiquette: 'verres-mini-160',
    garder: ['160', '167'],
    note: "Sur cette monture semi-cerclée, le verre est tenu par un fil nylon logé dans une rainure. Nous montons donc au minimum un verre aminci 1.6, plus résistant, pour que la rainure ne fragilise pas le verre à l'usage."
  };

  var moi = document.currentScript;
  if (!moi || !moi.src) { return; }

  [
    'lt-correctifs-tunnel',
    'lt-variante-suivie',
    'lt-prix-verres',
    'lt-garde-fous',
    'lt-aide-saisie',
    'lt-epaisseur-imposee',
    'lt-mutuelle',
    'lt-devis-patient',
    'lt-devis-lot1',
    'lt-devis-appairage',
    'lt-devis-solaire'
  ].forEach(function (nom) {
    var url = moi.src.replace('lt-correctifs', nom);
    if (url === moi.src) { return; }
    var s = document.createElement('script');
    s.src = url;
    s.defer = true;
    document.head.appendChild(s);
  });
})();